import { api } from './api';
import axios from 'axios';



export interface WooCommercePayload {
  store_url: string;
  store_name: string;
  api_version?: string;
  consumer_key: string;
  consumer_secret: string;
  user_id: number;
}

export const channelService = {

  async integrateWooCommerce(payload: WooCommercePayload) {
    const response = await axios.post(
      'https://channel.parcelpicks.com/api/channels/woocommerce',
      payload
    );

    return response.data;
  },

  async getAllChannels(userId: string | number) {
    const response = await api.get(`/channel/all-channels/${userId}`);
    return response.data;
  },

  async fetchPickupAddresses(userId: string | number, storeId: string | number) {
    const response = await api.get(`/channel/${userId}/upd/pickupAddress/${storeId}`);
    return response.data;
  },
};
